
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 76 76","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.313 54.938v7.218A4.813 4.813 0 0140.5 66.97h-9.625a4.813 4.813 0 01-4.813-4.813v-7.218M35.688 2v4.813M2 35.688h4.813m2.406-24.063l3.529 3.391m56.627 20.672h-4.813m-2.406-24.063l-3.529 3.391M25.79 54.938h19.796a21.175 21.175 0 0011.758-19.25A22.05 22.05 0 0035.688 14.03 22.051 22.051 0 0014.031 35.7a21.175 21.175 0 0011.76 19.236v0zm9.898 12.031v7.219m0-31.282v12.032","stroke":"#F6B722","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M28.469 35.688l7.218 7.218 7.22-7.218","stroke":"#F6B722","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    